// client/src/data/blogs.js
const blogs = [
  {
    slug: "mass-order-in-smsorbit",
    title: "What Is Mass Order In smsorbit And How To Use It?",
    category: "Guides",
    short:
      "Mass Order lets you create many orders at once using a simple text format. Perfect for agencies and resellers.",
    content: [
      "A mass order means placing many individual SMM orders in one go instead of submitting them one by one.",
      "In smsorbit you can paste multiple lines, each with service ID, link and quantity. The panel will automatically create a separate order for each line.",
      "Mass orders are ideal when you manage many posts, multiple profiles or campaigns for several clients.",
      "Before you submit a mass order, double–check that all links are correct and public, and that quantities respect the min/max limits of each service.",
    ],
  },
  {
    slug: "how-to-order-a-service-in-smsorbit",
    title: "How To Order A Service In smsorbit",
    category: "Getting Started",
    short:
      "Placing your first order takes less than a minute. Here’s a step-by-step walkthrough.",
    content: [
      "After logging in, go to the New Order page and pick the platform and service you want.",
      "Paste the link to your post or profile, then enter the quantity you need. The panel will show the estimated price automatically.",
      "Check the service description carefully: some services require specific types of links or have important notes about drops and refills.",
      "Once everything looks correct, click Place Order. Most services start within seconds and you can follow the progress from your Orders page.",
    ],
  },
  {
    slug: "funds-not-added-after-payment",
    title: "What To Do If Your Funds Have Not Been Added After Payment",
    category: "Billing",
    short:
      "Paid but balance is still the same? Here’s how to quickly fix missing funds issues.",
    content: [
      "Normally, Razorpay or PayPal payments are added to your smsorbit balance automatically within a few seconds.",
      "If your funds have not appeared after a few minutes, first refresh the wallet page and check your payment history.",
      "Make sure you used the correct payment amount and didn’t close the window before the gateway redirected you back to smsorbit.",
      "If the issue persists, open a support ticket and attach the payment ID or screenshot. Our team will verify the transaction and credit the balance manually.",
    ],
  },
];

export default blogs;
